// extracted by mini-css-extract-plugin
export default {"checkbox":"checkbox_checkbox__Ilsfh","checkmark":"checkbox_checkmark__Ll7+e","checkboxTextBlock":"checkbox_checkboxTextBlock__lV1h0","description":"checkbox_description__8OKkK"};